import { isStandaloneApp, getStandaloneAppId } from '@/utils/standaloneApp';

export default {
  state() {
    return {
      isStandaloneApp: isStandaloneApp(window.location.host),
      standaloneAppId: getStandaloneAppId(window.location.host),
    };
  },
  getters: {
    isStandaloneApp: state => state.isStandaloneApp,
    standaloneAppId: state => state.standaloneAppId,
  },
};
